import { render, staticRenderFns } from "./moneybag.vue?vue&type=template&id=ec370fba&scoped=true"
import script from "./moneybag.vue?vue&type=script&lang=js"
export * from "./moneybag.vue?vue&type=script&lang=js"
import style0 from "./moneybag.vue?vue&type=style&index=0&id=ec370fba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec370fba",
  null
  
)

export default component.exports